
import { Component, Prop, Vue } from "vue-property-decorator";
import { AuthenticationContext } from "vue-adal";
import axios from "axios";
import { EventBus } from "./helpers/EventBus";
import Dashboards from "./views/Dashboards";
import UserStatics from "./views/UserStatics";
@Component({
  components: {
    //Dashboards,
   // UserStatics
  }
})
export default class App extends Vue {
  public profile: any = {};
  public hostnameMode: string = "ers";
  @Prop() private msg!: string;

  public changeMode() {
    Vue.prototype.$hostMode = this.hostnameMode;
    localStorage.hostMode = this.hostnameMode;
    if (
      this.hostnameMode === "geniebot" &&
      ["spellingdictionaries", "blankpresentation", "palette"].includes(
        this.$route.name as string
      )
    ) {
      this.$router.push({ name: "acl" });
    }
    EventBus.$emit("mode-changed", this.hostnameMode);
  }

  public mounted() {
    this.profile = AuthenticationContext.user.profile;
    this.hostnameMode = localStorage.hostMode ? localStorage.hostMode : "ers";
    Vue.prototype.$hostMode = this.hostnameMode;
    const resource = process.env.VUE_APP_ADAL_APPID;
    AuthenticationContext.acquireToken(resource, (err, token) => {
      axios.interceptors.request.use(
        (config) => {
          const t = token;
          if (token) {
            config.headers.Authorization = `Bearer ${t}`;
          }
          config.baseURL = process.env.VUE_APP_API_BASE_URL;
          return config;
        },
        (error) => {
          return Promise.reject(error);
        }
      );

      if (err) {
        const errCode = err.split(":")[0];
        switch (errCode) {
          case "AADSTS50058": // Need to prompt for user sign in
            AuthenticationContext.login();
            break;
          case "AADSTS65001": // Token is invalid; grab a new one
            AuthenticationContext.acquireTokenRedirect(resource);
            break;
          case "AADSTS16000": // No Access
          default:
            // Need a pop-up forcing a login
            AuthenticationContext.login();
            break;
        }
        return;
      }
    });
  }

  public logout() {
    AuthenticationContext.logout();
  }
}
